import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_getOrdersByUserId = async (userId: string) => {
	const uri = `${BASE_URL}/orders/getByUser/${userId}`;
	const response = await fetch(uri, {
		method: 'GET',
	}).then((res) => res.json());
	return response;
};

export const api_getOrders = async (pageNo?: number, pageSize?: number) => {
	const page_number = pageNo || 1;
	const page_size = pageSize || 10;
	const uri = `${BASE_URL}/orders/?page=${page_number}&offset=${page_size}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`, // Add bearer token
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};
export const api_getOrdersByFilter = async (searchString: string) => {
	const uri = `${BASE_URL}/orders/filter?searchString=${searchString}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_makeOrder = async (payload: any) => {
	const uri = `${BASE_URL}/orders`;

	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`, // Add bearer token
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the order',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Order created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_getTotalOrders = async (status: string, date: string) => {
	const uri = `${BASE_URL}/orders/getTotal?status=${status}&date=${date}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_updateOrderStatus = async (orderId: string, payload: any) => {
	const uri = `${BASE_URL}/orders/${orderId}`;

	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};
